import { Link } from "@chakra-ui/react";
import { Trans, useTranslation } from "react-i18next";
import { Link as RouterLink } from "react-router-dom";
import { useSub } from "../../common/subscription/useSub";
import { urls } from "../../urls";

export const contractTypeSettingsPath = `${urls.app.settings}?tab=contract-types`;

export const NoContractTypesHint = ({ opensInNewTab = false }: { opensInNewTab?: boolean }) => {
  const { t } = useTranslation();
  const sub = useSub();
  if (!(sub.hasContractAccess && sub.canCreateContractTemplates)) {
    return <>{t("No contract types yet. Ask an administrator to add them.")}</>;
  }
  return (
    <Trans
      i18nKey="No contract types yet. Add them under <1>Settings</1>."
      components={{
        1: (
          <Link
            as={RouterLink}
            to={contractTypeSettingsPath}
            color="smPrimary"
            {...(opensInNewTab ? { target: "_blank", rel: "noopener noreferrer" } : {})}
          />
        ),
      }}
    />
  );
};
